<template>
    <div class="wrapper blog-post">
        <div class="page-header page-header-small">
            <parallax class="page-header-image" style="background-image: url('img/bg24.jpg')"></parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Planes de cobertura - OSAPM</h2>
                        <h4></h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <planes-detalle></planes-detalle>
        </div>
         
    </div>
</template>
<script>
  import { Card, Button, Comment, Badge, InfoSection, Checkbox } from '@/components';
  import PlanesDetalle from './cmsComponents/PlanesDetalle';

  export default {
    name: 'blog-post',
    bodyClass: 'blog-post',
    components: {
      Card,
      PlanesDetalle
    },
    data() {
      return {
      model:{}      
    };
    }
  }
</script>
<style>
</style>
